var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._g(_vm._b({tag:"component",staticClass:"c-link",attrs:{"to":_vm.to || null,"href":_vm.to,"target":_vm.external && '_blank'}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }